import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { concatMap, map, of, shareReplay, combineLatest, tap, Observable, combineAll, combineLatestWith } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CLO013 } from '../interface/clo013';
import { CLO026 } from '../interface/clo026';
import { CLO024 } from '../interface/clo024';
import { CLO025 } from '../interface/clo025';
import * as _ from 'lodash';
import { CLO032 } from '../interface/clo032';

@Injectable({
  providedIn: 'root'
})
export class SituationService {

  constructor(private httpClient: HttpClient, private auth: AuthService) {



  }

  private _clo013 = this.auth.stNo$.pipe(
    concatMap(stno =>
      this.httpClient.post<CLO013[]>(environment.apiUrl + `CLO013/${stno}`, undefined)
    ), shareReplay()
  );

  get CLO013() {
    return this._clo013.pipe(map(a => a[0]))
  }


  /** 畢業資格通過情形 (1) xxxx學系 */
  getCLO013(stno?: string) {
    if (stno) {
      return this.httpClient.post<CLO013[]>(environment.apiUrl + `CLO013/${stno}`, undefined);
    }
    return this._clo013;
  }


  // 是否學制=碩士班、碩士在職專班、產碩專班、博士班 'M', 'D', 'G', 'I'
  isGraduate() {
    return this.CLO013.pipe(
      map(a => ({ graduate: ['M', 'D', 'G', 'I'].includes(a.degreE_CODE), degreE_CODE: a.degreE_CODE, depenD_AYEAR: a.depenD_AYEAR, teacH_GRP: a.teacH_GRP })),
      shareReplay()
    )
  }

  situation() {


    return this.isGraduate().pipe(
      concatMap(a => (a.graduate == true) ? this.block2(a.degreE_CODE, a.depenD_AYEAR, a.teacH_GRP) : this.block1(a.degreE_CODE, a.depenD_AYEAR, a.teacH_GRP)),
      map(a => _.filter(a, b => b.pass != '無門檻資料' && b.percent != undefined))
    )

  }

  /** 大學
   *
   * O = 學士後
      1.學士班：學制=學士後，不呈現"通識課程"、"語言檢定"、"游泳檢定"、"服務學習"、"體育必修"欄位
   *
  */

  private block1(degreE_CODE: string, depenD_AYEAR: string, teacH_GRP: string) {
    const general = this.getCLO026().pipe(map(a => a[0]), shareReplay());
    const concatMail = 'https://aca.tmu.edu.tw/app/news.php?Sn=2382';
    // 教務學務系統必選修科目表
    const helpStr = 'https://newacademic.tmu.edu.tw/outside.aspx?mainPage=QQBwAHAAbABpAGMAYQB0AGkAbwBuAC8ARQBOAFIALwBFAE4AUgBBADAALwBFAE4AUgBBADEAMgAwAF8AMAAxAC4AYQBzAHAAeAA/AHAAcgBvAGcAYwBkAD0ARQBOAFIAQQAxADIAMAA=&ENROLL_AYEAR=' + depenD_AYEAR + '&FACULTY_CODE=' + teacH_GRP;

    //通識
    const clo022_3 =
      this.getCLO022('3').pipe(
        combineLatestWith(general),
        // withLatestFrom(general),
        map(([a, b]) => ({
          title: '通識課程',
          percent: _.round(a),
          pass: b?.iS_GENERAL_GRAD_NAME,
          help: 'http://geducation.tmu.edu.tw/zh_tw/laws/Course',
          mail: of(concatMail)
        }))
      );

    //語言檢定
    const c23_b97 = this.getCLO023('B97').pipe(
      map(a => ({
        title: '語言檢定',
        percent: a?.status,
        pass: a?.result,
        help: 'http://lc.tmu.edu.tw/course/super_pages.php?ID=course1',
        mail: of(concatMail)
      })
      ));

    //游泳檢定
    // const c23_b99 = srv.getCLO023('B99').pipe(shareReplay());
    const c23_b99 = this.getCLO023('B99').pipe(
      map(a => ({
        title: '游泳檢定',
        percent: a?.status,
        pass: a?.result,
        help: 'https://pe.tmu.edu.tw/%e6%95%99%e5%ad%b8%e8%88%87%e8%a8%ad%e6%96%bd%e7%b5%84/%e9%ab%94%e8%82%b2%e6%8a%80%e8%83%bd%e6%aa%a2%e5%ae%9a/',
        mail: of(concatMail)
      })
      ));

    //服務學習
    const clo022_5 = this.getCLO022('5').pipe(
      combineLatestWith(general),
      map(([a, b]) => ({
        title: '服務學習',
        percent: _.round(a),
        pass: b?.iS_SERV_GRAD_NAME,
        help: helpStr,
        mail: of(concatMail)
      }))
    );

    //體育必修
    const clo022_4 = this.getCLO022('4').pipe(
      combineLatestWith(general),
      map(([a, b]) => ({
        title: '體育必修',
        percent: _.round(a),
        pass: b?.iS_SPORT_GRAD_NAME,
        help: helpStr,
        mail: of(concatMail)
      }))
    );

    //專業必修學分
    const clo022_1 = this.getCLO022('1').pipe(
      combineLatestWith(general),
      map(([a, b]) => ({
        title: '專業必修學分',
        percent: _.round(a),
        pass: b?.iS_FACULTY_GRAD_NAME,
        help: helpStr,
        mail: this.getMail()
      }))
    );

    //專業選修學分
    const clo022_2 = this.getCLO022('2').pipe(
      combineLatestWith(general),
      map(([a, b]) => ({
        title: '專業選修學分',
        percent: _.round(a),
        pass: b?.iS_FACULTY_GRAD_NAME,
        help: helpStr,
        mail: this.getMail()
      }))
    );

    //微學程畢業門檻
    const minipro = general.pipe(
      map(a => ({
        title: '微學程畢業門檻',
        percent: (a?.iS_PROG_GRAD == '1') ? 100 : 0,
        pass: a?.iS_PROG_GRAD_NAME,
        help: helpStr,
        mail: this.getMail()
      })
      )
    );


    // O = 學士後
    //   1.學士班：學制=學士後，不呈現"通識課程"、"語言檢定"、"游泳檢定"、"服務學習"、"體育必修"欄位
    if (degreE_CODE == 'O') {
      return combineLatest([clo022_1, clo022_2, minipro]);
    }
    else {
      return combineLatest([clo022_3, c23_b97, c23_b99, clo022_5,
        clo022_4, clo022_1, clo022_2, minipro]
      );
    }



  }


  /** 研究所：
 *
    M = 碩士班
    G = 碩士在職專班
    I = 產碩專班
      2.研究所：(1)學制=碩士班、碩士在職專班、產碩專班，不呈現"資格考"欄位；(2)E-mail未呈現
 *
 *
*/
  private block2(degreE_CODE: string, depenD_AYEAR: string, teacH_GRP: string) {
    const general = this.getCLO026().pipe(map(a => a[0]), shareReplay());
    // // 教務學務系統必選修科目表
    const helpStr = 'https://newacademic.tmu.edu.tw/outside.aspx?mainPage=QQBwAHAAbABpAGMAYQB0AGkAbwBuAC8ARQBOAFIALwBFAE4AUgBBADAALwBFAE4AUgBBADEAMgAwAF8AMAAxAC4AYQBzAHAAeAA/AHAAcgBvAGcAYwBkAD0ARQBOAFIAQQAxADIAMAA=&ENROLL_AYEAR' + depenD_AYEAR + '&FACULTY_CODE=' + teacH_GRP;

    // 畢業門檻-英文能力
    const clo035 = this.CLO035('1').pipe(
      map(a => ({
        title: '畢業門檻-英文能力',
        percent: a?.status,
        pass: a?.status >= 100 ? '通過' : '未通過',
        help: helpStr,
        mail: this.getMail()
      })));

    // 畢業門檻-系所自訂

    const clo035_2 = this.CLO035('2').pipe(
      map(a => ({
        title: '畢業門檻-系所自訂',
        percent: a?.status,
        pass: a?.status >= 100 ? '通過' : '未通過',
        help: helpStr,
        mail: this.getMail()
      })));


    //專業必修課程
    const clo022_1 = this.getCLO022('1').pipe(
      combineLatestWith(general),
      map(([a, b]) => ({
        title: '專業必修課程',
        percent: _.round(a),
        pass: b?.iS_FACULTY_GRAD_NAME,
        help: helpStr,
        mail: this.getMail()
      }))
    );

    //專業選修課程
    const clo022_2 = this.getCLO022('2').pipe(
      combineLatestWith(general),
      map(([a, b]) => ({
        title: '專業選修課程',
        percent: _.round(a),
        pass: b?.iS_FACULTY_GRAD_NAME,
        help: helpStr,
        mail: this.getMail()
      }))
    );


    //資格考
    const clo034_1 = this.CLO034('1').pipe(
      map(a => ({
        title: '資格考',
        percent: a.length > 0 ? 100 : 0,
        pass: a.length > 0 ? '通過' : '未通過',
        help: helpStr,
        mail: this.getMail()
      })));

    //碩博士論文課程
    const clo034_2 = this.CLO034('2').pipe(
      map(a => ({
        title: '碩博士論文課程',
        percent: a.length > 0 ? 100 : 0,
        pass: a.length > 0 ? '通過' : '未通過',
        help: helpStr,
        mail: this.getMail()
      })));


    // M = 碩士班
    // G = 碩士在職專班
    // I = 產碩專班
    //   2.研究所：(1)學制=碩士班、碩士在職專班、產碩專班，不呈現"資格考"欄位；(2)E-mail未呈現


    if (degreE_CODE == 'M' || degreE_CODE == 'G' || degreE_CODE == 'I') {
      return combineLatest([
        clo035, clo035_2, clo022_1, clo022_2, clo034_2
      ]);
    } else {
      return combineLatest([
        clo035, clo035_2, clo022_1, clo022_2, clo034_1, clo034_2
      ]);
    }
  }

  private getMail() {
    return this.getCLO013().pipe(
      map(a => a[0]),
      concatMap(g => this.getCLO031(g.teacH_GRP, g.grade.toString(), this.isForeign(g))),
      map(a => `mailto:${a[0]}`));
  }

  private isForeign(g: CLO013) {
    return g.presenT_TYPE == '02' ? '2' : '1';
  }


  /**
   *
   * Code:1  資格考
   *
   * Code:2  碩博士論文課程
   */
  CLO034(code: '1' | '2') {
    const re = this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<{
          stno: string,
          typE_CODE: string
        }[]>(environment.apiUrl + `CLO034/${stno}/${code}`, undefined)
      ));
    return re;
  }

  /**
   *  Code:1    畢業門檻-英文能力
   *  Code:2   畢業門檻-系所自訂
   * @param code
   *
   * @returns
   */
  CLO035(code: '1' | '2') {
    const re = this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<{
          status: number,
          result: string
        }[]>(environment.apiUrl + `CLO035/${stno}/${code}`, undefined)
      ));
    return re.pipe(map(a => a[0]));

  }

  getWarning(type: 'CLO003' | 'CLO005' | 'CLO004') {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<any>(environment.apiUrl + `${type}/${stno}`, undefined)
      ),
      map(a => _.orderBy(a, b => b.ayearsms, 'asc'))

    );
  }



  /** 畢業資格通過情形
   * 通識課程達成狀況. Code:3
   * 服務學習 Code:5
   * 體育必修 Code:4
   * 專業必修學分 Code:1
   * 專業選修學分 Code:2
   */
  getCLO022(code: '1' | '2' | '3' | '4' | '5') {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<number>(environment.apiUrl + `CLO022/${stno}/${code}`, undefined)
      ));
  }


  /**
   *  * 語言,游泳 -  審核結果
   * 語言檢定 B97
   * 游泳檢定 B99
   */
  getCLO023(code: 'B97' | 'B99') {

    const re = this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<{
          status: number,
          result: string
        }[]>(environment.apiUrl + `CLO023/${stno}/${code}`, undefined)
      ));

    return re.pipe(map(a => a[0]));
  }

  /** 審核結果 */
  getCLO026() {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO026[]>(environment.apiUrl + `CLO026/${stno}`, undefined)
      )

    );
  }

  getCLO024(stno?: string) {


    if (stno)
      return this.httpClient.post<CLO024[]>(environment.apiUrl + `CLO024/${stno}`, undefined)

    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO024[]>(environment.apiUrl + `CLO024/${stno}`, undefined)
      ));
  }
  /** 輔系/雙主修 */
  getCLO025() {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO025[]>(environment.apiUrl + `CLO025/${stno}`, undefined)
      )

    );
  }

  getCLO031(APP_FACULTY_CODE: string, grade: string, foreign: string) {
    return this.httpClient.post<string[]>(environment.apiUrl + `CLO031/${APP_FACULTY_CODE}/${grade}/${foreign}`, undefined)
  }

  getCLO032() {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<CLO032[]>(environment.apiUrl + `CLO032/${stno}`, undefined)
      )

    );
  }


  /**
   *  應修畢業門檻次數=t1,
   *  已修門檻次數=t2,
   *  應修 - 已修 = t3
   * @returns 應修畢業門檻次數=t1, 已修門檻次數=t2   t3  應修 - 已修
   */
  GetGraduate() {
    return this.auth.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<{ t1: number, t2: number }[]>(environment.apiUrl + `GetGraduate/${stno}`, undefined)
      ),
      map(a => ({
        t1: a[0].t1,
        t2: a[0].t2,
        t3: a[0].t1 - a[0].t2,
        percent: _.round(a[0].t2 / a[0].t1, 1) * 100
      }))

    );
  }

}
